import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "./ui/button";

export const Header = ({ onOpenEstimateModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-black/95 backdrop-blur-sm shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <img
              src="/img/logo.png"
              alt="Samaniega's Landscaping"
              className="h-12 w-auto"
            />
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-white">
                Samaniega&apos;s Landscaping
              </h1>
              <p className="text-xs text-green-400">LLC</p>
            </div>
          </div>

          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("home")}
              className="text-white hover:text-green-400 transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection("gallery")}
              className="text-white hover:text-green-400 transition-colors"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-white hover:text-green-400 transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("why-choose-us")}
              className="text-white hover:text-green-400 transition-colors"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="text-white hover:text-green-400 transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-white hover:text-green-400 transition-colors"
            >
              Contact
            </button>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <a
              href="tel:2067080084"
              className="flex items-center space-x-2 text-white hover:text-green-400 transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">(206) 708-0084</span>
            </a>

            <Button
              type="button"
              onClick={onOpenEstimateModal}
              className="bg-green-500 hover:bg-green-600 text-black font-semibold"
            >
              Get Free Estimate
            </Button>
          </div>

          <button
            type="button"
            className="lg:hidden text-white"
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-sm py-4 mb-2 rounded-lg">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection("home")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection("gallery")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("why-choose-us")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                Why Choose Us
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="text-white hover:text-green-400 transition-colors px-4 text-left"
              >
                Contact
              </button>

              <div className="px-4 pt-2 border-t border-gray-700">
                <a
                  href="tel:2067080084"
                  className="flex items-center space-x-2 text-white hover:text-green-400 transition-colors mb-3"
                >
                  <Phone className="h-4 w-4" />
                  <span className="text-sm font-medium">(206) 708-0084</span>
                </a>

                <Button
                  type="button"
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    onOpenEstimateModal();
                  }}
                  className="w-full bg-green-500 hover:bg-green-600 text-black font-semibold"
                >
                  Get Free Estimate
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
